import apiClient from './apiClient';

export const dashboardApi = {
  getDashboardData: (almataId, oemId = '') => {
    return apiClient.get(`/partners/almata-partners/dashboard/data?almataId=${almataId}&oemId=${oemId}`);
  }
};

export default dashboardApi;